<template>
    <div class="bg">
        <form class="form--login">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                        <div class="info_block">
                            <h1>{{$t('logo_text')}}</h1>
                            <p v-html="$t('auth.login_description')"></p>
                            <img src="/static/img//smileys/smiley-success--gray.png"/>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="form__content">
                            <h1>{{$t('auth.signin')}}</h1>
                            <p>{{$t('auth.signin_exp')}}</p>
                            <div class="alert--error" v-if="error !== undefined && error.length > 0">{{error}}</div>

                            <div class="form__item">
                                <i class="form__icon icons icon-envelope"></i>
                                <input class="form__input--text" type="email" name='email' autocomplete="email" v-model="email" :placeholder="$t('auth.hint_email')"/>
                            </div>

                            <div class="form__item">
                                <i class="form__icon icons icon-lock"></i>
                                <i class="mdi form__password_icon" :class="[showPassword ? 'mdi-eye' : 'mdi-eye-off']" @click="showPassword = !showPassword"></i>
                                <input class="form__input--text" :type="showPassword ? 'text' : 'password'" autocomplete="password" name="password" v-model="password" :placeholder="$t('auth.hint_password')"/>
                            </div>

                            <div class="form__button_container">
                                <button @click.prevent="login" class="button--alt orange" :class="{'is-loading' : $store.state.auth.loading}">{{$t('auth.button_signin')}}</button>
                                <!-- <router-link class="button--cta" :to="{ name: 'register' }"><strong>{{$t('auth.button_new_account')}}</strong></router-link><br /> -->
                            </div>
                        </div>
                        <div class="form__forgot-password">
                            <p>{{$t('auth.link_forgot_password')}}</p>
                            <a :href="$config.eportfolioURL + 'wachtwoord-vergeten?app=kds'" class="button--link">{{$t('auth.button_forgot_pass')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class LoginForm extends Vue {
        name = 'login-form';

        error = '';

        email = '';
        password = '';
        showPassword = false;

        /**
         * Validate email and password and sign a user in.
         */
        login() {
            this.error = undefined;

            this.$auth.signInWithUsernameAndPassword(this.email, this.password)
                .then(() => {
                    var redirect = this.$route.query.redirect;
                    if (redirect) {
                        this.$router.replace(redirect);
                    } else {
                        this.$router.replace({
                            name: 'evaluation-students'
                        });
                    }
                })
                .catch(({status, errors}) => {
                    this.error = errors[0];
                });
        }
    }

    Vue.component('login-form', LoginForm);
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/LoginForm.vue